(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bundle-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Format cents using the shop's money format ("€{{amount}}" etc.) */
    function money(cents, fmt) {
      var amount = (cents / 100).toFixed(2);
      var whole = String(Math.round(cents / 100));
      var comma = amount.replace('.', ',');
      var out = (fmt || '${{amount}}').replace(/<[^>]*>/g, '');
      return out.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return whole;
          case 'amount_no_decimals_with_comma_separator': return whole;
          case 'amount_with_comma_separator': return comma;
          case 'amount_with_space_separator': return comma;
          case 'amount_with_apostrophe_separator': return amount;
          case 'amount_with_period_and_space_separator': return amount;
          default: return amount;
        }
      });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
        if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
        var dlg = drawer.querySelector('dialog');
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
      }
      var trigger = document.querySelector('[data-cart-drawer-trigger], .cart-drawer__trigger, .header-actions__cart-icon, a[href$="/cart"].header-actions__action, header-actions a[href$="/cart"]');
      if (trigger) { trigger.click(); return true; }
      return false;
    }

    function refreshCartUI(root, sections) {
      /* Swap in re-rendered cart sections returned by Shopify (if any) */
      if (sections) {
        Object.keys(sections).forEach(function (id) {
          var target = document.getElementById('shopify-section-' + id);
          if (!target || !sections[id]) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = sections[id];
          var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
          if (fresh) target.replaceWith(fresh);
        });
      }
      fetch(root.getAttribute('data-cart-json-url'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var detail = {
            resource: null,
            sourceId: root.getAttribute('data-block-id'),
            data: { source: 'product-form-component', itemCount: cart.item_count, sections: sections || {} }
          };
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
        })
        .catch(function () {});
    }

    function init(root) {
      if (root.getAttribute('data-bb-ready')) return;
      root.setAttribute('data-bb-ready', '1');

      var fmt = root.getAttribute('data-money-format');
      var discounts = (root.getAttribute('data-tier-discounts') || '0,0,0,0')
        .split(',').map(function (n) { return parseFloat(n) || 0; });
      var afterAdd = root.getAttribute('data-after-add') || 'drawer';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var addUrl = root.getAttribute('data-add-url') || '/cart/add';
      var unlockText = root.getAttribute('data-unlock-text') || 'Add {n} more to unlock {p}% off.';
      var maxText = root.getAttribute('data-max-text') || 'Max discount unlocked.';
      var addedText = root.getAttribute('data-added-text') || 'Added to cart';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
      var list = root.querySelector('[data-list]');
      var scrollHint = root.querySelector('[data-scroll-hint]');
      var hint = root.querySelector('[data-hint]');
      var fill = root.querySelector('[data-track-fill]');
      var cta = root.querySelector('[data-cta]');
      var ctaText = root.querySelector('[data-cta-text]');
      var errEl = root.querySelector('[data-error]');
      var sumCount = root.querySelector('[data-summary-count]');
      var sumSave = root.querySelector('[data-summary-save]');
      var sumWas = root.querySelector('[data-summary-was]');
      var sumTotal = root.querySelector('[data-summary-total]');
      var ctaBase = ctaText ? ctaText.textContent : 'Add bundle to cart';
      var target = 0;

      var basePrice = 0;
      for (var i = 0; i < items.length; i++) {
        var pr = parseInt(items[i].getAttribute('data-price'), 10);
        if (pr > 0) { basePrice = pr; break; }
      }

      function tierIndex(qty) {
        if (qty >= 4) return 3;
        if (qty <= 0) return -1;
        return qty - 1;
      }

      function discountFor(qty) {
        var t = tierIndex(qty);
        return t < 0 ? discounts[0] : discounts[t];
      }

      for (var t = 1; t <= 4; t++) {
        var d = discounts[t - 1];
        var ea = Math.round(basePrice * (1 - d / 100));
        var offEl = root.querySelector('[data-tier-off="' + t + '"]');
        var eaEl = root.querySelector('[data-tier-ea="' + t + '"]');
        var wasEl = root.querySelector('[data-tier-was="' + t + '"]');
        if (offEl) offEl.textContent = d > 0 ? Math.round(d) + '% OFF' : '';
        if (eaEl) eaEl.textContent = money(ea, fmt) + '/ea';
        if (wasEl) wasEl.textContent = d > 0 ? money(basePrice * t, fmt) : '';
      }

      function getQty(item) {
        return parseInt(item.getAttribute('data-qty') || '0', 10);
      }

      function setQty(item, q) {
        q = Math.max(0, q);
        item.setAttribute('data-qty', q);
        var add = item.querySelector('[data-add]');
        var stepper = item.querySelector('[data-stepper]');
        var qtyEl = item.querySelector('[data-qty]');
        if (qtyEl) qtyEl.textContent = q;
        if (add) add.hidden = q > 0;
        if (stepper) stepper.hidden = q === 0;
        update();
      }

      function update() {
        var total = 0, subtotal = 0;
        items.forEach(function (it) {
          var q = getQty(it);
          total += q;
          subtotal += q * parseInt(it.getAttribute('data-price'), 10);
        });

        var d = discountFor(total);
        var discounted = Math.round(subtotal * (1 - d / 100));
        var saving = subtotal - discounted;
        var ti = tierIndex(total);

        var pct = total <= 0 ? 0 : total >= 4 ? 100 : ((total - 1) / 3) * 100;
        if (fill) fill.style.width = (pct * 0.75) + '%';

        for (var t = 1; t <= 4; t++) {
          var dot = root.querySelector('[data-tier-dot="' + t + '"]');
          if (!dot) continue;
          dot.classList.toggle('is-reached', total >= t);
          dot.classList.toggle('is-active', ti === t - 1);
        }

        if (hint) {
          if (target > total) {
            hint.textContent = unlockText.replace('{n}', target - total).replace('{p}', Math.round(discounts[tierIndex(target)]));
          } else if (total > 0 && total < 4 && discounts[ti + 1] > d) {
            hint.textContent = unlockText.replace('{n}', 1).replace('{p}', Math.round(discounts[ti + 1]));
          } else if (total >= 4) {
            hint.textContent = maxText;
          } else {
            hint.textContent = '';
          }
        }

        if (sumCount) sumCount.textContent = total === 1 ? '1 item' : total + ' items';
        if (sumSave) sumSave.textContent = saving > 0 ? 'You save ' + money(saving, fmt) : '';
        if (sumWas) sumWas.textContent = saving > 0 ? money(subtotal, fmt) : '';
        if (sumTotal) sumTotal.textContent = money(discounted, fmt);
        if (cta) cta.disabled = total === 0;
        if (ctaText) ctaText.textContent = total > 0 ? ctaBase + ' \u2014 ' + money(discounted, fmt) : ctaBase;
      }

      items.forEach(function (it) {
        var add = it.querySelector('[data-add]');
        var plus = it.querySelector('[data-plus]');
        var minus = it.querySelector('[data-minus]');
        if (add) add.addEventListener('click', function () { setQty(it, 1); });
        if (plus) plus.addEventListener('click', function () { setQty(it, getQty(it) + 1); });
        if (minus) minus.addEventListener('click', function () { setQty(it, getQty(it) - 1); });
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-tier-pick]'), function (btn) {
        btn.addEventListener('click', function () {
          target = parseInt(btn.getAttribute('data-tier-pick'), 10);
          update();
          if (list) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });

      function checkScroll() {
        if (!list || !scrollHint) return;
        var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 4;
        var canScroll = list.scrollHeight > list.clientHeight + 4;
        scrollHint.classList.toggle('is-hidden', !canScroll || atEnd);
      }
      if (list) list.addEventListener('scroll', checkScroll);
      if (scrollHint) scrollHint.addEventListener('click', function () {
        list.scrollBy({ top: list.clientHeight * 0.8, behavior: 'smooth' });
      });
      window.addEventListener('resize', checkScroll);
      checkScroll();

      if (cta) cta.addEventListener('click', function () {
        var lines = [];
        items.forEach(function (it) {
          var q = getQty(it);
          if (q > 0) lines.push({ id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: q });
        });
        if (!lines.length) return;

        cta.classList.add('is-loading');
        if (errEl) errEl.hidden = true;

        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lines, sections: 'cart-drawer,cart-icon-bubble' })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            cta.classList.remove('is-loading');
            if (!res.ok) {
              if (errEl) { errEl.textContent = res.body.description || res.body.message || 'Could not add to cart.'; errEl.hidden = false; }
              return;
            }

            if (afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
            if (afterAdd === 'cart') { window.location.href = cartUrl; return; }

            refreshCartUI(root, res.body.sections);
            items.forEach(function (it) { setQty(it, 0); });
            if (ctaText) ctaText.textContent = addedText;
            setTimeout(update, 1800);

            if (afterAdd === 'drawer') {
              setTimeout(function () {
                if (!openCartDrawer()) window.location.href = cartUrl;
              }, 150);
            }
          })
          .catch(function () {
            cta.classList.remove('is-loading');
            if (errEl) { errEl.textContent = 'Could not add to cart. Please try again.'; errEl.hidden = false; }
          });
      });

      update();
    }

    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bundle-builder]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Format cents using the shop's money format ("€{{amount}}" etc.) */
    function money(cents, fmt) {
      var amount = (cents / 100).toFixed(2);
      var whole = String(Math.round(cents / 100));
      var comma = amount.replace('.', ',');
      var out = (fmt || '${{amount}}').replace(/<[^>]*>/g, '');
      return out.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return whole;
          case 'amount_no_decimals_with_comma_separator': return whole;
          case 'amount_with_comma_separator': return comma;
          case 'amount_with_space_separator': return comma;
          case 'amount_with_apostrophe_separator': return amount;
          case 'amount_with_period_and_space_separator': return amount;
          default: return amount;
        }
      });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
        if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
        var dlg = drawer.querySelector('dialog');
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
      }
      var trigger = document.querySelector('[data-cart-drawer-trigger], .cart-drawer__trigger, .header-actions__cart-icon, a[href$="/cart"].header-actions__action, header-actions a[href$="/cart"]');
      if (trigger) { trigger.click(); return true; }
      return false;
    }

    /* Replace a rendered section in place. Works for both the HTML Shopify
       returns from /cart/add.js and HTML fetched via ?section_id=. */
    function swapSection(id, html) {
      if (!html) return false;
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return false;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
      if (!fresh) return false;
      target.replaceWith(fresh);
      return true;
    }

    /* Refresh the cart drawer and the header count, then tell the theme.
       Horizon's drawer lives in the "cart-drawer" section; if Shopify didn't
       hand it back with the add response, fetch it directly. Resolves when
       the page is up to date, so the drawer can open with fresh contents. */
    function refreshCartUI(root, sections) {
      var rootUrl = root.getAttribute('data-root-url') || '/';
      var haveDrawer = sections && sections['cart-drawer'] && swapSection('cart-drawer', sections['cart-drawer']);

      var drawerReady = haveDrawer
        ? Promise.resolve()
        : fetch(rootUrl + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) { swapSection('cart-drawer', html); })
            .catch(function () {});

      return drawerReady
        .then(function () {
          return fetch(root.getAttribute('data-cart-json-url'), { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
          if (count !== null) {
            Array.prototype.forEach.call(
              document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child, .cart-bubble__count, cart-icon .count'),
              function (el) { el.textContent = count; }
            );
          }
          var detail = {
            resource: null,
            sourceId: root.getAttribute('data-block-id'),
            data: { source: 'product-form-component', itemCount: count, sections: sections || {} }
          };
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
        })
        .catch(function () {});
    }

    function init(root) {
      if (root.getAttribute('data-bb-ready')) return;
      root.setAttribute('data-bb-ready', '1');
      if (window.console) console.info('[Bundle Builder] v9 running');

      var fmt = root.getAttribute('data-money-format');
      var discounts = (root.getAttribute('data-tier-discounts') || '0,0,0,0')
        .split(',').map(function (n) { return parseFloat(n) || 0; });
      var afterAdd = root.getAttribute('data-after-add') || 'drawer';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var addUrl = root.getAttribute('data-add-url') || '/cart/add';
      var unlockText = root.getAttribute('data-unlock-text') || 'Add {n} more to unlock {reward}.';
      var maxText = root.getAttribute('data-max-text') || 'Max discount unlocked.';
      var anotherFreeText = root.getAttribute('data-another-free-text') || '';
      var addedText = root.getAttribute('data-added-text') || 'Added to cart';
      var unit = root.getAttribute('data-unit') || '';
      var useMain = root.getAttribute('data-use-main') === 'true';
      var syncMain = root.getAttribute('data-sync-main') === 'true';
      var pills = (root.getAttribute('data-pills') || '|||').split('|');
      var freeAfter = parseInt(root.getAttribute('data-free-after') || '0', 10) || 0;
      var freeRepeat = root.getAttribute('data-free-repeat') === 'true';
      var tierFree = (root.getAttribute('data-tier-free') || '0,0,1,0')
        .split(',').map(function (n) { return n === '1'; });
      var freeBtnText = root.getAttribute('data-free-button') || 'Free +';
      var freePill = root.getAttribute('data-free-pill') || '{f} FREE';
      var lineFreeText = root.getAttribute('data-line-free') || 'Free jar ({f}x)';
      var lineDiscountText = root.getAttribute('data-line-discount') || '{p}% bundle discount';
      var notes = (root.getAttribute('data-notes') || '|||').split('|');
      var sumNote = root.querySelector('[data-summary-note]');

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
      var list = root.querySelector('[data-list]');
      var scrollHint = root.querySelector('[data-scroll-hint]');
      var hint = root.querySelector('[data-hint]');
      var fill = root.querySelector('[data-track-fill]');
      var cta = root.querySelector('[data-cta]');
      var ctaText = root.querySelector('[data-cta-text]');
      var errEl = root.querySelector('[data-error]');
      var sumCount = root.querySelector('[data-summary-count]');
      var sumSave = root.querySelector('[data-summary-save]');
      var sumWas = root.querySelector('[data-summary-was]');
      var sumTotal = root.querySelector('[data-summary-total]');
      var breakdown = root.querySelector('[data-breakdown]');
      var lineSubtotal = root.querySelector('[data-line-subtotal]');
      var lineFreeRow = root.querySelector('[data-line-free-row]');
      var lineFreeLabel = root.querySelector('[data-line-free-label]');
      var lineFree = root.querySelector('[data-line-free]');
      var lineDiscRow = root.querySelector('[data-line-discount-row]');
      var lineDiscLabel = root.querySelector('[data-line-discount-label]');
      var lineDisc = root.querySelector('[data-line-discount]');
      var ctaBase = ctaText ? ctaText.textContent : 'Add bundle to cart';
      var target = 0;
      var busy = false;

      var basePrice = 0;
      for (var i = 0; i < items.length; i++) {
        var pr = parseInt(items[i].getAttribute('data-price'), 10);
        if (pr > 0) { basePrice = pr; break; }
      }

      /* ---------------- Pricing rules (display only) ----------------
         Free item: "Buy X get 1 free". With freeAfter = 2, the 3rd item is free.
         With repeat on, every full set earns one (6 items = 2 free), which is how
         a Shopify Buy X Get Y discount works when uses per order aren't limited.
         The free item is always the cheapest one, like Shopify does it.
         Tier %: applies to the items that are paid for, at the tier reached.
         Each tier chooses whether it includes the free item. */
      var freeEvery = freeAfter > 0 ? freeAfter + 1 : 0;

      function tierIndex(qty) {
        if (qty >= 4) return 3;
        if (qty <= 0) return -1;
        return qty - 1;
      }

      function discountFor(qty) {
        var t = tierIndex(qty);
        return t < 0 ? 0 : discounts[t];
      }

      /* Free item only at tiers that include it: e.g. 3 jars = 1 free,
         4+ jars = 1 free + 20% off the jars that are paid for. */
      function freeCountFor(qty) {
        if (!freeEvery || qty < freeEvery) return 0;
        if (!tierFree[tierIndex(qty)]) return 0;
        return freeRepeat ? Math.floor(qty / freeEvery) : 1;
      }

      /* units = array of unit prices in cents, one entry per item */
      function priceUnits(units) {
        var n = units.length;
        var d = discountFor(n);
        var f = freeCountFor(n);
        var sorted = units.slice().sort(function (a, b) { return a - b; });
        var full = 0, paid = 0, freeValue = 0;
        for (var k = 0; k < n; k++) {
          full += sorted[k];
          if (k < f) {
            freeValue += sorted[k];
          } else {
            paid += Math.round(sorted[k] * (1 - d / 100));
          }
        }
        /* freeValue = the free jar's full original price (never reduced by the tier %).
           discountValue = what the tier % takes off the jars that are paid for. */
        return {
          count: n,
          full: full,
          paid: paid,
          free: f,
          freeValue: freeValue,
          discount: d,
          discountValue: full - freeValue - paid
        };
      }

      function sameUnits(qty) {
        var arr = [];
        for (var k = 0; k < qty; k++) arr.push(basePrice);
        return arr;
      }

      /* What a tier gives, e.g. "10% OFF", "1 FREE", "1 FREE + 20% OFF" */
      function rewardLabel(t) {
        var d = Math.round(discounts[t - 1]);
        var f = freeCountFor(t);
        var custom = (pills[t - 1] || '').trim();
        if (custom) return custom.replace('{p}', d).replace('{f}', f);
        var parts = [];
        if (f > 0) parts.push(freePill.replace('{f}', f));
        if (d > 0) parts.push(d + '% OFF');
        return parts.join(' + ');
      }

      function unlockMessage(n, t) {
        var txt = unlockText;
        /* Older saved text says "{p}% off" — when the next tier is a free item,
           swap that phrase for the real reward so it never reads "0% off". */
        if (freeCountFor(t) > 0 && txt.indexOf('{reward}') === -1) {
          txt = txt.replace(/\{p\}\s*%\s*off/i, '{reward}');
        }
        return txt
          .replace('{n}', n)
          .replace('{reward}', rewardLabel(t))
          .replace('{p}', Math.round(discounts[t - 1]));
      }

      /* Tier row: per-item price = what you pay for that many / that many */
      for (var t = 1; t <= 4; t++) {
        var tier = priceUnits(sameUnits(t));
        var ea = Math.round(tier.paid / t);
        var offEl = root.querySelector('[data-tier-off="' + t + '"]');
        var eaEl = root.querySelector('[data-tier-ea="' + t + '"]');
        var wasEl = root.querySelector('[data-tier-was="' + t + '"]');
        var noteEl = root.querySelector('[data-tier-note="' + t + '"]');
        if (offEl) offEl.textContent = rewardLabel(t);
        if (eaEl) eaEl.textContent = money(ea, fmt) + unit;
        if (wasEl) wasEl.textContent = tier.paid < tier.full ? money(basePrice, fmt) + unit : '';
        if (noteEl) noteEl.textContent = (notes[t - 1] || '').trim();
      }

      function getQty(item) {
        return parseInt(item.getAttribute('data-qty') || '0', 10);
      }

      function bundleTotal() {
        var n = 0;
        items.forEach(function (it) { n += getQty(it); });
        return n;
      }

      function setQty(item, q) {
        q = Math.max(0, q);
        item.setAttribute('data-qty', q);
        var add = item.querySelector('[data-add]');
        var stepper = item.querySelector('[data-stepper]');
        var qtyEl = item.querySelector('[data-qty]');
        if (qtyEl) qtyEl.textContent = q;
        if (add) add.hidden = q > 0;
        if (stepper) stepper.hidden = q === 0;
        update();
      }

      /* Display only. The cart is priced by Shopify's automatic discounts;
         nothing computed here changes what gets added. */
      function update() {
        var units = [];
        items.forEach(function (it) {
          var q = getQty(it);
          var price = parseInt(it.getAttribute('data-price'), 10) || 0;
          for (var k = 0; k < q; k++) units.push(price);
        });

        var total = units.length;
        var result = priceUnits(units);
        var saving = result.full - result.paid;
        var ti = tierIndex(total);

        /* The next Add is the free one when it would earn another free item */
        var nextIsFree = freeEvery > 0 && freeCountFor(total + 1) > freeCountFor(total);
        items.forEach(function (it) {
          var add = it.querySelector('[data-add]');
          if (!add) return;
          if (!add.getAttribute('data-label')) add.setAttribute('data-label', add.textContent);
          add.textContent = nextIsFree ? freeBtnText : add.getAttribute('data-label');
          add.classList.toggle('is-free', nextIsFree);
        });

        var pct = total <= 0 ? 0 : total >= 4 ? 100 : ((total - 1) / 3) * 100;
        if (fill) fill.style.width = (pct * 0.75) + '%';

        for (var t = 1; t <= 4; t++) {
          var dot = root.querySelector('[data-tier-dot="' + t + '"]');
          if (!dot) continue;
          dot.classList.toggle('is-reached', total >= t);
          dot.classList.toggle('is-active', ti === t - 1);
        }

        if (hint) {
          var nextTier = total + 1;
          if (target > total) {
            hint.textContent = unlockMessage(target - total, target);
          } else if (total > 0 && total < 4 && rewardLabel(nextTier) && rewardLabel(nextTier) !== rewardLabel(total)) {
            hint.textContent = unlockMessage(1, nextTier);
          } else if (total >= 4) {
            /* Past the top tier: when one more jar earns another free one
               (5 -> 6 with "every 3rd free"), say so, so nobody stops at 5. */
            var oneMoreFree = anotherFreeText && freeCountFor(total + 1) > freeCountFor(total);
            hint.textContent = oneMoreFree ? anotherFreeText.replace('{n}', 1) : maxText;
          } else {
            hint.textContent = '';
          }
        }

        if (sumCount) sumCount.textContent = total === 1 ? '1 item' : total + ' items';
        if (sumSave) sumSave.textContent = saving > 0 ? 'You save ' + money(saving, fmt) : '';
        if (sumWas) sumWas.textContent = saving > 0 ? money(result.full, fmt) : '';
        if (sumTotal) sumTotal.textContent = money(result.paid, fmt);

        /* Itemized: Subtotal / free jar at its full price / tier % on the rest */
        if (breakdown) {
          breakdown.hidden = saving <= 0;
          if (lineSubtotal) lineSubtotal.textContent = money(result.full, fmt);
          if (lineFreeRow) lineFreeRow.hidden = result.freeValue <= 0;
          if (lineFreeLabel) lineFreeLabel.textContent = lineFreeText.replace('{f}', result.free);
          if (lineFree) lineFree.textContent = '-' + money(result.freeValue, fmt);
          if (lineDiscRow) lineDiscRow.hidden = result.discountValue <= 0;
          if (lineDiscLabel) lineDiscLabel.textContent = lineDiscountText.replace('{p}', Math.round(result.discount));
          if (lineDisc) lineDisc.textContent = '-' + money(result.discountValue, fmt);
        }
        if (sumNote) sumNote.textContent = ti >= 0 ? (notes[ti] || '').trim() : '';
        if (cta) cta.disabled = total === 0;
        if (ctaText) ctaText.textContent = total > 0 ? ctaBase + ' \u2014 ' + money(result.paid, fmt) : ctaBase;
        if (useMain && syncMain) syncMainButton(total, result.paid);
      }

      /* ---- theme's main add-to-cart button ---- */
      var mainForm = null, mainBtn = null, mainBtnOriginal = null;

      function isMainForm(form) {
        return !!(form && form.matches && form.matches('form[action*="/cart/add"]') && !root.contains(form));
      }

      function findMainForm() {
        if (mainForm && document.contains(mainForm)) return mainForm;
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) {
          if (isMainForm(forms[i]) && forms[i].querySelector('button[type="submit"], [type="submit"]')) {
            mainForm = forms[i];
            break;
          }
        }
        return mainForm;
      }

      function syncMainButton(total, payable) {
        var form = findMainForm();
        if (!form) return;
        var btn = form.querySelector('button[type="submit"], [type="submit"]');
        if (!btn) return;
        if (btn !== mainBtn) { mainBtn = btn; mainBtnOriginal = null; }
        var label = btn.querySelector('span') || btn;
        if (mainBtnOriginal === null) mainBtnOriginal = label.textContent;
        label.textContent = total > 0
          ? ctaBase + ' \u2014 ' + money(payable, fmt)
          : mainBtnOriginal;
      }

      /* Add exactly what's selected: one line per variant, the chosen quantity.
         Two rows that resolve to the same variant are merged here on purpose,
         so what we send is what Shopify would store anyway — and the browser
         console says so, which is the fastest way to spot a slot pointing at
         the wrong variant. */
      function addLines(done) {
        var byId = {}, order = [];
        items.forEach(function (it) {
          var q = getQty(it);
          if (q <= 0) return;
          var id = parseInt(it.getAttribute('data-variant-id'), 10);
          if (byId[id]) {
            byId[id] += q;
            if (window.console) console.warn('[Bundle Builder] Two rows share variant ' + id + ' ("' + it.getAttribute('data-title') + '"). Set a Variant on each slot so scents are distinct.');
          } else { byId[id] = q; order.push(id); }
        });
        var lines = order.map(function (id) { return { id: id, quantity: byId[id] }; });
        if (window.console) console.info('[Bundle Builder] adding', lines.map(function (l) {
          var row = items.filter(function (it) { return parseInt(it.getAttribute('data-variant-id'), 10) === l.id; })[0];
          return l.quantity + '× ' + (row ? row.getAttribute('data-title') + ' / ' + row.getAttribute('data-variant-title') : l.id) + ' (' + l.id + ')';
        }));
        if (!lines.length) { if (done) done(false); return; }
        if (errEl) errEl.hidden = true;

        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lines, sections: 'cart-drawer' })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errEl) { errEl.textContent = res.body.description || res.body.message || 'Could not add to cart.'; errEl.hidden = false; }
              if (done) done(false);
              return;
            }
            if (afterAdd === 'checkout') { window.location.href = '/checkout'; return; }
            if (afterAdd === 'cart') { window.location.href = cartUrl; return; }
            items.forEach(function (it) { setQty(it, 0); });
            refreshCartUI(root, res.body.sections).then(function () {
              if (afterAdd === 'drawer' && !openCartDrawer()) window.location.href = cartUrl;
              if (done) done(true);
            });
          })
          .catch(function () {
            if (errEl) { errEl.textContent = 'Could not add to cart. Please try again.'; errEl.hidden = false; }
            if (done) done(false);
          });
      }

      /* When a bundle is selected, the theme's own Add to cart must never run
         its default action — otherwise the page's product gets added on top
         of the bundle. We take over at the earliest possible moment: the
         click on the button, in the capture phase, before any theme handler
         (Horizon reacts to the click as well as the submit). The submit
         listener catches keyboard submits and any code path that skips the
         click. `busy` stops a click and a submit from both firing an add. */
      function takeOver(e, form) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (busy) return;
        busy = true;
        var btn = form.querySelector('button[type="submit"], [type="submit"]');
        if (btn) btn.setAttribute('aria-busy', 'true');
        addLines(function () {
          busy = false;
          if (btn) btn.removeAttribute('aria-busy');
        });
      }

      if (useMain) {
        /* window fires before document in the capture phase, so this runs ahead
           of the theme's delegated handlers no matter which script loaded first. */
        window.addEventListener('click', function (e) {
          if (bundleTotal() === 0) return;
          var ctrl = e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
          if (!ctrl) return;
          var form = ctrl.form || ctrl.closest('form');
          if (!isMainForm(form)) return;
          var type = (ctrl.getAttribute('type') || 'submit').toLowerCase();
          if (ctrl.tagName === 'BUTTON' && type !== 'submit') return;
          takeOver(e, form);
        }, true);

        window.addEventListener('submit', function (e) {
          var form = e.target;
          if (!isMainForm(form) || bundleTotal() === 0) return;
          takeOver(e, form);
        }, true);
      }

      items.forEach(function (it) {
        var add = it.querySelector('[data-add]');
        var plus = it.querySelector('[data-plus]');
        var minus = it.querySelector('[data-minus]');
        if (add) add.addEventListener('click', function () { setQty(it, 1); });
        if (plus) plus.addEventListener('click', function () { setQty(it, getQty(it) + 1); });
        if (minus) minus.addEventListener('click', function () { setQty(it, getQty(it) - 1); });
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-tier-pick]'), function (btn) {
        btn.addEventListener('click', function () {
          target = parseInt(btn.getAttribute('data-tier-pick'), 10);
          update();
          if (list) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });

      function checkScroll() {
        if (!list || !scrollHint) return;
        var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 4;
        var canScroll = list.scrollHeight > list.clientHeight + 4;
        scrollHint.classList.toggle('is-hidden', !canScroll || atEnd);
      }
      if (list) list.addEventListener('scroll', checkScroll);
      if (scrollHint) scrollHint.addEventListener('click', function () {
        list.scrollBy({ top: list.clientHeight * 0.8, behavior: 'smooth' });
      });
      window.addEventListener('resize', checkScroll);
      checkScroll();

      if (cta) cta.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        cta.classList.add('is-loading');
        addLines(function (ok) {
          busy = false;
          cta.classList.remove('is-loading');
          if (ok && ctaText) { ctaText.textContent = addedText; setTimeout(update, 1800); }
        });
      });

      update();
    }

    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bundle-builder]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
